import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { FAQSchema } from "@/components/SEO";

const faqs = [
  {
    question: "How much does a handyman cost in Newport Beach?",
    answer: "OC Tasker provides free estimates for all projects. Costs vary depending on the scope — a simple TV mounting starts around $149, while larger projects are custom-quoted. We're transparent about pricing with no hidden fees. Use our online calculators for instant quotes on TV mounting, window cleaning, and pressure washing."
  },
  {
    question: "Are you insured?",
    answer: "Yes! OC Tasker is fully insured for handyman work in Newport Beach and throughout Orange County. Every job comes with our workmanship guarantee for your complete peace of mind."
  },
  {
    question: "What areas do you serve?",
    answer: "We serve Newport Beach, Costa Mesa, Huntington Beach, Irvine, Laguna Beach, Newport Coast, Corona Del Mar, and Fountain Valley. If you're nearby but not listed, give us a call — we likely cover your area too."
  },
  {
    question: "How quickly can you get to my home?",
    answer: "We often have same-day or next-day availability. For our Property Maintenance Membership members, we offer priority scheduling. Call (949) 204-0301 for current availability."
  },
  {
    question: "Can I get multiple repairs done in one visit?",
    answer: "Absolutely! That's one of our most popular options. Bring your full to-do list and we'll knock out as many items as possible in a single visit, saving you time and money."
  },
  {
    question: "Do you offer free estimates?",
    answer: "Yes — all estimates are free with no obligation. Most are answered within 30 minutes. You can request one online, call us at (949) 204-0301, or use our instant quote calculators for immediate pricing."
  },
  {
    question: "What's included in your Property Maintenance Membership?",
    answer: "Our membership includes scheduled visits, preventive care, priority scheduling, and discounted rates. It's the easiest way to keep your home in top shape year-round without having to think about it."
  },
  {
    question: "Do you guarantee your work?",
    answer: "Yes. Every job comes with our satisfaction guarantee. If you're not happy with the work, we'll make it right. We stand behind the quality of our craftsmanship."
  }
];

export function HomepageFAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="py-16 bg-white" data-testid="homepage-faq">
      <FAQSchema faqs={faqs} />
      <div className="max-w-3xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-gray-900 text-center mb-2">Frequently Asked Questions</h2>
        <p className="text-gray-500 text-center mb-10">Quick answers to common questions about our handyman services</p>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                className="w-full flex items-center justify-between p-5 text-left hover:bg-gray-50 transition-colors"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                data-testid={`homepage-faq-${i}`}
              >
                <span className="font-semibold text-gray-900 pr-4">{faq.question}</span>
                {openIndex === i
                  ? <ChevronUp className="w-5 h-5 text-gray-400 shrink-0" />
                  : <ChevronDown className="w-5 h-5 text-gray-400 shrink-0" />
                }
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5 text-gray-600 leading-relaxed border-t border-gray-100 pt-4">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
